import { BottomSheetModal } from '@gorhom/bottom-sheet';
import BoostInfoBottomSheet, {
  BoostInfoBottomSheetProps,
} from 'features/rewards/components/BoostInfoBottomSheet/BoostInfoBottomSheet';
import React, { useRef } from 'react';
import { StyleSheet, View } from 'react-native';
import VXLPromoCard, {
  VXLPromoCardProps,
} from 'shared/components/vxl/cards/VXLPromoCard/VXLPromoCard';
import theme from 'shared/styles/theme';

export interface BoostPromoCardProps {
  cardData: VXLPromoCardProps;
  details: Omit<
    BoostInfoBottomSheetProps,
    'bottomSheetRef' | 'onSubmit' | 'onDismiss'
  >;
}

const BoostPromoCard = ({ cardData, details }: BoostPromoCardProps) => {
  const bottomSheetRef = useRef<BottomSheetModal>(null);

  const handlePress = () => {
    bottomSheetRef.current?.present();
  };

  const handleDismiss = () => {
    bottomSheetRef.current?.dismiss();
  };

  return (
    <View style={styles.container}>
      <VXLPromoCard {...cardData} onPress={handlePress} />
      <BoostInfoBottomSheet
        bottomSheetRef={bottomSheetRef}
        title={details.title}
        body={details.body}
        primaryButton={details.primaryButton}
        onSubmit={handleDismiss}
        onDismiss={handleDismiss}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: theme.spacing.m,
    paddingTop: theme.spacing.s,
  },
});

export default BoostPromoCard;
